import {
  createContext,
  useContext,
  useState,
  useEffect,
  ReactNode,
} from 'react';
import { useAuth } from './authContext';
import { isUndefined } from 'lodash';
import { GetSweepContextType } from './getSweepContext.type';
import { Sweep } from '../../utils/helper.type';

const SweepContext = createContext<GetSweepContextType | undefined>(undefined);

export const SweepProvider = ({ children }: { children: ReactNode }) => {
  const [sweepSummary, setSweepSummary] = useState<Sweep[]>([]);

  const { accessToken } = useAuth();

  useEffect(() => {
    console.log({ accessToken });

    if (isUndefined(accessToken)) {
      setSweepSummary([]);
      return;
    }
  }, [accessToken]);

  return (
    <SweepContext.Provider value={{ sweepSummary, setSweepSummary }}>
      {children}
    </SweepContext.Provider>
  );
};

export const useSweepSummary = (): GetSweepContextType => {
  const context = useContext(SweepContext);
  if (!context) throw new Error('useAuth must be used inside AuthProvider');
  return context;
};
